import store from '@/store'
import router, { resetRouter } from '@/router'
import request from '@/request'
import ErrorCode from '@/request/error-code'
import { ElLoading } from 'element-plus'
// import cacheSessionStorage from '../cache/cacheSessionStorage'
import cacheInLocalStorage from '../cache/cacheInLocalStorage'

const getters = {
  token_temp: state => state.token_temp,
  username_temp: state => state.username_temp,
  token: state => state.token,
  role: state => state.role,
  userinfo: state => state.userinfo,
  userPermission: state => state.userPermission,
  requestsBeforeLogout: state => state.requestsBeforeLogout
}

const state = {
  token_temp: '',
  username_temp: '',
  token: cacheInLocalStorage.get('token'),
  role: cacheInLocalStorage.get('role'),
  userinfo: cacheInLocalStorage.get('userinfo'),
  userPermission: cacheInLocalStorage.get('userPermission'),
  requestsBeforeLogout: null
}

const mutations = {
  SET_TOKEN_TEMP: (state, token) => {
    state.token_temp = token
  },
  SET_USERNAME_TEMP: (state, username) => {
    state.username_temp = username
  },
  SET_TOKEN: (state, token) => {
    state.token = token
    cacheInLocalStorage.set('token', token)
  },
  SET_ROLE: (state, role) => {
    state.role = role
    cacheInLocalStorage.set('role', role)
  },
  SET_INFO: (state, info) => {
    state.userinfo = info
    cacheInLocalStorage.set('userinfo', info)
  },
  SET_USER_PERMISSION: (state, permissions) => {
    state.userPermission = permissions
    cacheInLocalStorage.set('userPermission', permissions)
  },
  SET_REQUESTS_BEFORE_LOGOUT: (state, infos) => {
    state.requestsBeforeLogout = infos
  }
}

const actions = {
  LOGIN({ commit }, { data, role, username, isNoRouter }) {
    return new Promise((resolve, reject) => {
      request({
        url: '/auth/login',
        method: 'POST',
        data,
        headers: {
          ContentType: 'multipart/form-data'
        },
        hideErrorMessage: true
      }).then(res => {
        commit('SET_TOKEN', res)
        commit('SET_ROLE', role)
        resolve()
      }).catch((res) => {
        commit('SET_TOKEN_TEMP', res.data)
        commit('SET_USERNAME_TEMP', username)
        commit('SET_ROLE', role)
        commit('SET_INFO', {
          userName: username
        })
        if (res.code === ErrorCode.ErrRequestNewUser) {
          if (!isNoRouter) {
            router.replace({ path: '/pass-reset' })
          }
        } else if (res.code === ErrorCode.ErrRequestNeedUpdatePassword) {
          commit('SET_INFO', {
            userName: username
          })
          router.replace({ path: '/pass-update' })
        } else if (res.code === ErrorCode.ErrRequestAccountTransfer) {
          cacheInLocalStorage.set('transferAuthorization', JSON.stringify(res.data))
          router.replace({ path: '/account-transfer' })
        }
        reject(res)
      })
    })
  },
  LOGIN_WITH_NO_PASSWORD({ commit }, { role, username, isNoRouter }) {
    return new Promise((resolve, reject) => {
      request({
        url: '/api/v1/oauth/token/test',
        method: 'GET',
        params: {
          userName: username
        },
        headers: {
          ContentType: 'multipart/form-data'
        }
      }).then(res => {
        commit('SET_TOKEN', res)
        commit('SET_ROLE', role)
        resolve()
      }).catch((res) => {
        commit('SET_TOKEN_TEMP', res.data)
        commit('SET_USERNAME_TEMP', username)
        commit('SET_ROLE', role)
        commit('SET_INFO', {
          userName: username
        })
        if (res.code === ErrorCode.ErrRequestNewUser) {
          if (!isNoRouter) {
            router.replace({ path: '/pass-reset' })
          }
        } else if (res.code === ErrorCode.ErrRequestNeedUpdatePassword) {
          commit('SET_INFO', {
            userName: username
          })
          router.replace({ path: '/pass-update' })
        } else if (res.code === ErrorCode.ErrRequestAccountTransfer) {
          cacheInLocalStorage.set('transferAuthorization', JSON.stringify(res.data))
          router.replace({ path: '/account-transfer' })
        }
        reject(res)
      })
    })
  },
  LOGOUT({ commit }) {
    return new Promise(resolve => {
      const loadingInstance = ElLoading.service({
        lock: true,
        text: '正在退出...',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      setTimeout(() => {
        loadingInstance.close()
        commit('SET_TOKEN', '')
        store.commit('permission/SET_ROUTES', [])
        commit('SET_INFO', {})
        commit('SET_USER_PERMISSION', [])
        resetRouter()
        cacheInLocalStorage.remove('isEasyClearIdLogin')
        cacheInLocalStorage.remove('upsId')
        cacheInLocalStorage.remove('isB')
        cacheInLocalStorage.remove('staffInfo')
        resolve()
      }, 2000)
    })
  },
  GET_INFO_CUSTOMER({ commit }) {
    return new Promise((resolve) => {
      request({
        url: '/api/v1/customer/profile',
        method: 'GET'
      }).then(res => {
        commit('SET_INFO', {
          userName: res.username,
          department: res.companyName,
          portCode: res.portCode,
          postalCode: res.postalCode,
          isLocked: res.isLocked ? res.isLocked : false,
          companyName: res.companyName,
          upsAccount: res.upsAccount,
          upsId: res.upsId,
          accountNo: res.accountNo
        })
        resolve(res)
      })
    })
  },
  GET_INFO_ADMIN({ commit }) {
    return new Promise((resolve, reject) => {
      request({
        url: '/api/v1/staff/profile',
        method: 'GET',
        hideErrorMessage: true
      }).then(res => {
        console.log('GET_INFO_ADMIN=>staffInfo:', res)
        cacheInLocalStorage.set('staffInfo', JSON.stringify(res))
        commit('SET_INFO', {
          userName: res.staffId,
          department: res.roleList[0].roleCode,
          staffEmail: res.staffEmail,
          roleCode: res.roleList[0].roleCode,
          fixedRole: res.roleList[0].roleCode,
          sortNo: res.roleList[0].sortNo
        })
        resolve()
      }).catch(() => {
        reject()
      })
    })
  },
  getUserPermission({ commit }) {
    return new Promise((resolve, reject) => {
      request({
        url: '/api/v1/user-permissions',
        hideErrorMessage: true
      }).then((res) => {
        commit('SET_USER_PERMISSION', res)
        resolve()
      }).catch((error) => {
        reject(error)
      })
    })
  },
  LOGOUT_CLEARN_DATAS({ commit }) {
    commit('SET_TOKEN', '')
    store.commit('permission/SET_ROUTES', [])
    commit('SET_INFO', {})
    commit('SET_USER_PERMISSION', [])
    resetRouter()
    cacheInLocalStorage.remove('isEasyClearIdLogin')
    cacheInLocalStorage.remove('upsId')
    cacheInLocalStorage.remove('isB')
    cacheInLocalStorage.remove('staffInfo')
  }
}

export default {
  namespaced: true,
  getters,
  state,
  mutations,
  actions
}
